import { get } from 'lodash';

const root = state => get(state, 'UtilitiesState.updateBidDetails');

export const getBidDetailsData = state =>
  get(root(state), 'bidDetailsData', null);
export const getBidPriceDetails = state =>
  get(getBidDetailsData(state), 'BidPriceDetails', []);
export const getBidPriceBeginDate = state =>
  get(getBidDetailsData(state), 'BidPriceBeginDate', null);
export const getBidPriceEndDate = state =>
  get(getBidDetailsData(state), 'BidPriceEndDate', null);
export const getLoadingBidDetails = state =>
  get(root(state), 'loadingBidDetails', false);
export const getBidDetailsLoadingError = state =>
  get(root(state), 'bidDetailsLoadingError', null);
export const getIsSubmittingBidPrice = state =>
  get(root(state), 'isSubmittingBidPrice', false);
export const getSubmitted = state => get(root(state), 'submitted', false);
export const getSubmitError = state => get(root(state), 'submitError', null);
export const getPrintData = state => get(root(state), 'printData', '');



// WEBPACK FOOTER //
// ./src/pages/utilities/state/updateBidDetails/selectors.js